<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Contratos del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          dark
          class="ma-2"
          @click="$router.push('/admin/contratos/form')"
          >Crear Contrato</v-btn
        >
        <!--<v-btn
          color="info"
          dark
          class="ma-2"
          @click="$router.push('/admin/contratos/plantillas')"
          >Plantillas</v-btn
        >-->
        <v-spacer />

        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="contratos"
        :loading="loading"
        sort-by="ultimaFecha"
        sort-desc
      >
        <template v-slot:item.tipo="{ item }">
          {{ item.id }}
        </template>

        <template v-slot:item.estadoMostrar="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip small class="mr-2 pa-1 info" v-on="on"
                ><v-icon color="white">mdi-information</v-icon></v-chip
              >
            </template>
            <span>{{ item.estado }} </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.firmaGenerada ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-draw</v-icon></v-chip
              >
            </template>
            <span v-if="!item.firmaGenerada">No generada firma</span>
            <span v-else>Generada firma</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.enviadoEmail ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-email</v-icon></v-chip
              >
            </template>
            <span v-if="!item.enviadoEmail">No enviado por email</span>
            <span v-else>Enviado por email: {{ item.enviadoEmail }}</span>
          </v-tooltip> -->
          <v-tooltip top v-if="!!item.firmado">
            <template v-slot:activator="{ on }">
              <v-chip small class="mr-2 pa-1 success" v-on="on"
                ><v-icon color="white">mdi-check</v-icon></v-chip
              >
            </template>
            <span>Firmado cliente</span>
          </v-tooltip>
          <v-tooltip top v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                x-small
                class="mr-2 pa-1 red"
                v-on="on"
                @click="comprobarFirma(item)"
                :loading="item.loadingComprobar"
                ><v-icon color="white">mdi-check</v-icon></v-btn
              >
            </template>
            <span>No firmado</span>
          </v-tooltip>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                :color="item.visible ? 'success' : 'red'"
                min-width="0"
                v-on="on"
                :loading="item.loadingVisible"
                small
                @click="cambiarVisible(item)"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Visible para el cliente</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                small
                v-on="on"
                @click="openDialogFicheros(item)"
              >
                <v-icon class="white--text" small>mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Ficheros {{ item.nombre }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="primary"
                min-width="0"
                small
                v-on="on"
                @click="openDialogHistorial(item)"
              >
                <v-icon class="white--text" small>mdi-newspaper</v-icon>
              </v-btn>
            </template>
            <span>Historial {{ item.nombre }}</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="blue lighten-3"
                min-width="0"
                small
                v-on="on"
                @click="openFicherosDialog(item)"
              >
                <v-icon class="white--text" small>mdi-email</v-icon>
              </v-btn>
            </template>
            <span>Enviar ficheros {{ item.nombre }}</span>
          </v-tooltip> -->

          <v-tooltip top>
            <template
              v-slot:activator="{ on }"
              v-if="item.estado == 'generado'"
            >
              <v-btn
                class="px-2 ml-1"
                color="success"
                min-width="0"
                v-on="on"
                :loading="generarLoading"
                small
                @click="generarFirmaDialog(item)"
              >
                <v-icon small>mdi-draw</v-icon>
              </v-btn>
            </template>
            <span>Generar Firma</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="eliminarContrato(item)"
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                :loading="loadingEliminar"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar contrato</span>
          </v-tooltip>
        </template>
      </v-data-table></base-material-card
    >
    <!-- DIALOG GEENEREAR FIRMA-->
    <!--dialogo enviar ficheros-->
    <v-dialog max-width="700" v-model="generarDialog">
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">Generar Firma Click&Sign</v-card-title>
          <v-card-subtitle
            >Generar Firma con los siguientes emails</v-card-subtitle
          >
          <v-card-text>
            <v-text-field label="emails" v-model="generarEmailsComputado" />
          </v-card-text>
        </v-row>
        <v-card-actions>
          <v-spacer />
          <v-btn class="secondary" @click="generarDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="primary" @click="generarFirma" :loading="generarLoading"
            >Generar Firma</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHistorial" max-width="900">
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">Historial</v-card-title>
          <v-card-subtitle>Contrato {{ modalItem.nombre }}</v-card-subtitle>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel v-for="(h, i) in historialComputed" :key="i">
                <v-expansion-panel-header>
                  <v-row no-gutters align="center">
                    <v-col cols="1">
                      <v-chip class="grey white--text">{{
                        historialComputed.length - i
                      }}</v-chip>
                    </v-col>
                    <v-col cols="6">{{
                      h && h.mensaje ? h.mensaje : "sin titulo"
                    }}</v-col>
                    <v-col cols="2" class="text--secondary">{{
                      h && h.usuario ? h.usuario : "sin usuario"
                    }}</v-col>
                    <v-col cols="3" class="text--secondary">{{
                      h && h.fechaMostrar ? h.fechaMostrar : "sin fecha"
                    }}</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{
                  h && h.adicional ? h.adicional : "Sin más información"
                }}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogFicheros" max-width="600">
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">FICHEROS</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="f in modalItem.ficheros" :key="f.nombre">
                <v-list-item-title> {{ f.nombre }}</v-list-item-title
                ><v-list-item-action
                  ><v-icon @click="openFichero(f.url)" x-large color="primary"
                    >mdi-open-in-new</v-icon
                  ></v-list-item-action
                >
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
    <!--dialogo enviar ficheros-->
    <v-dialog max-width="700" v-model="enviarFicherosDialog">
      <v-card class="mx-auto">
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-card-title class="mb-4">Ficheros a enviar</v-card-title>
            <v-card-subtitle
              >Selecciona los ficheros que quieres enviar</v-card-subtitle
            >
            <v-card-text>
              <v-list-item-group v-model="ficherosEnviar" multiple>
                <v-list-item
                  value="sinFirmar"
                  :disabled="modalItem && !modalItem.ficheroSinFirmar"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Contrato </v-list-item-title>
                      <v-list-item-subtitle
                        >antes de firma</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <v-list-item
                  value="listado"
                  :disabled="modalItem && !modalItem.ficheroFirmado"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Contrato</v-list-item-title>
                      <v-list-item-subtitle>Firmado</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card-title class="mb-4">Emails a enviar</v-card-title>
            <v-card-subtitle
              >Selecciona los emails a los que quieres enviar</v-card-subtitle
            >
            <v-card-text>
              <v-list-item-group v-model="emailsEnviar" multiple>
                <v-list-item
                  :value="e"
                  v-for="(e, i) in [
                    'deku.quintreo',
                  ] /*datosFacturacion.emails*/"
                  :key="i"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ e }}</v-list-item-title>
                      <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-card-text>
          </v-col>
          <v-card-actions>
            <v-btn
              large
              class="primary"
              @click="enviarFicheros"
              :loading="btnAccionesLoading"
              >Enviar</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loadingComprobar: false,
      btnAccionesLoading: false,
      ficherosEnviar: [],
      emailsEnviar: [],
      modalItem: {},
      enviarFicherosDialog: false,
      dialogFicheros: false,
      dialogHistorial: false,
      generarDialog: false,
      generarEmails: [],
      generarLoading: false,
      generarItem: null,
      loading: false,
      loadingEliminar: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Cliente",
          value: "clienteMostrar",
        },
        // {
        //   sortable: false,
        //   text: "Tipo",
        //   value: "tipo",
        // },
        {
          sortable: false,
          text: "Estado",
          width: "20%",
          value: "estadoMostrar",
        },
        {
          sortable: false,
          width: "30%",
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    generarEmailsComputado: {
      get() {
        return this.generarEmails ? this.generarEmails.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.generarEmails = val.split(expresionRegular);
      },
    },
    historialComputed() {
      return this.modalItem.historial
        ? this.modalItem.historial
            .map((h) => {
              return {
                ...h,
                fechaMostrar: moment
                  .unix(h.fecha)
                  .format("DD-MM-YYYY HH:mm:ss"),
              };
            })
            .sort((a, b) => {
              return b.fecha - a.fecha - 1;
            })
        : [];
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      // contratos: (state) => state.contratos.contratos,
    }),
    contratos() {
      var contratos = this.$store.state.contratos.contratos;
      var res = [];
      var firmaGenerada = false;
      var firmado = false;
      contratos.forEach((c) => {
        let historial = c.historial
          ? c.historial.sort((a, b) => {
              return b.fecha - a.fecha - 1;
            })
          : [];
        firmaGenerada = !!c.historial.find(
          (h) => h.accion == "cambio estado ready"
        );
        firmado = !!c.historial.find((h) => h.accion == "cambio estado signed");
        // var foundFirma, index;
        // index = c.historial ? c.historial.length - 1 : -1;
        // for (; index >= 0; index--) {
        //   if (c.historial[index].generadaFirma != undefined) {
        //     foundFirma = c.historial[index];
        //     break;
        //   }
        // }
        // let generadaFirma;
        // if (foundFirma) {
        //   generadaFirma = moment(foundFirma.generadaFirma.toDate()).format(
        //     "DD-MM-YYYY HH:mm"
        //   );
        // } else {
        //   generadaFirma = false;
        // }
        // var foundEmail, index;
        // index = c.historial ? c.historial.length - 1 : -1;
        // for (; index >= 0; index--) {
        //   if (c.historial[index].enviadoEmail != undefined) {
        //     foundEmail = c.historial[index];
        //     break;
        //   }
        // }
        // let enviadoEmail;
        // if (foundEmail) {
        //   enviadoEmail = moment(foundCobrado.enviadoEmail.toDate()).format(
        //     "DD-MM-YYYY HH:mm"
        //   );
        // } else {
        //   enviadoEmail = false;
        // }
        // var foundFirmado, index;
        // index = c.historial ? c.historial.length - 1 : -1;
        // for (; index >= 0; index--) {
        //   if (c.historial[index].firmadoCliente != undefined) {
        //     foundFirmado = c.historial[index];
        //     break;
        //   }
        // }
        // let firmadoCliente;
        // if (foundFirmado) {
        //   firmadoCliente = moment(foundFirmado.firmadoCliente.toDate()).format(
        //     "DD-MM-YYYY HH:mm"
        //   );
        // } else {
        //   firmadoCliente = false;
        // }

        var foundGenerado = historial.find((h) => h.accion == "generado");
        var foundFirmado = historial.find((h) => h.accion == "firmado");
        var last =
          historial.length > 0 ? historial[historial.length - 1] : null;
        res.push({
          ...c,
          id: c.id,
          nombre: c.nombre,
          clienteMostrar: idToTexto(c.cliente),
          estadoMostrar: idToTexto(c.estado),
          fechaGenerado: foundGenerado ? foundGenerado.fecha : null,
          fechaGenerado: foundGenerado ? foundGenerado.fecha : null,
          ultimaFecha: last ? last.fecha : null,
          firmaGenerada: firmaGenerada,
          firmado: firmado,
        });
      });
      return res.sort((a, b) => {
        return b.ultimaFecha - a.ultimaFecha;
      });
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de contratos de todo el sistema";
    },
  },
  watch: {},
  methods: {
    comprobarFirma(item) {
      let _vm = this;
      item.loadingComprobar = true;
      return this.$store
        .dispatch("contratos/comprobarContrato", item)

        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Contrato comprobado ",
          });
          _vm.reload();
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido comprobar el contrato " + e,
          });
        })
        .finally(() => {
          item.loadingComprobar = false;
        });
    },
    cambiarVisible(item) {
      let _vm = this;
      item.loadingVisible = true;
      item.visible = !item.visible;
      return this.$store
        .dispatch("contratos/cambiarVisibilidad", item)

        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Visibilidad cambiada",
          });
          _vm.reload();
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido cambiar la visibilidad " + e,
          });
        })
        .finally(() => {
          item.loadingVisible = false;
        });
    },
    async openFicherosDialog() {
      // this.ficherosEnviar = ["facturas"];
      // this.emailsEnviar = this.datosFacturacion.emails;
      this.emailsDefecto = await this.$store.dispatch(
        "facturacion/getEmailsDefecto"
      );
      // let em = this.datosFacturacion.emails ? this.datosFacturacion.emails : [];
      // this.datosFacturacion.emails = _.union(
      //   this.datosFacturacion.emails,
      //   this.emailsDefecto
      // );
      this.enviarFicherosDialog = true;
    },
    enviarFicheros() {},
    openFichero(url) {
      window.open(url, "_blanks");
    },
    openDialogHistorial(item) {
      this.modalItem = item;
      this.dialogHistorial = true;
    },
    openDialogFicheros(item) {
      this.modalItem = item;
      this.dialogFicheros = true;
    },
    async generarFirmaDialog(item) {
      this.generarItem = item;
      this.generarDialog = true;
      this.generarLoading = true;
      var datosFact;
      if (item.modo == "negocio") {
        datosFact = await this.$store.dispatch(
          "negocios/getFacturacion",
          item.cliente
        );
      } else if (item.modo == "restaurante") {
        datosFact = await this.$store.dispatch(
          "restaurantes/getFacturacion",
          item.cliente
        );
      } else if (item.modo == "partner") {
        datosFact = await this.$store.dispatch(
          "partners/getFacturacion",
          item.cliente
        );
      }
      this.generarEmails =
        datosFact && datosFact.emails ? datosFact.emails : [];
      this.generarLoading = false;
    },
    generarFirma() {
      let _vm = this;

      this.$confirm("¿Desea generar firma del contrato?", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((r) => {
          if (r) {
            _vm.generarLoading = true;
            confirm = true;
            return this.$store.dispatch("contratos/generarFirma", {
              contrato: this.generarItem.id,
              emails: this.generarEmails,
            });
          }
        })
        .then((r) => {
          if (r) {
            if (r.ok) {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Firma generada de contrato",
              });
              _vm.generarDialog = false;
            } else {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "No se ha podido firmar el contrato " + r.error.msj,
              });
            }
            _vm.reload();
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido firmar el contrato " + e,
          });
        })
        .finally(() => {
          _vm.generarLoading = false;
        });
    },
    goPdf(item) {
      this.$store.dispatch("contratos/generarPdf", item.id);
    },
    eliminarContrato(item) {
      let _vm = this;
      var confirm = false;
      this.$confirm(
        "¿Desea eliminar el contrato? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      )
        .then((r) => {
          if (r) {
            confirm = true;
            item.loadingEliminar = true;
            return this.$store.dispatch("contratos/eliminarContrato", item.id);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Contrato eliminado",
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar el contrato: " + e,
          });
        })
        .finally(() => {
          item.loadingEliminar = false;
          _vm.reload();
        });
    },

    reload() {
      let _vm = this;
      _vm.loading = true;
      this.$store
        .dispatch("contratos/getContratos")
        .then(() => {})
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar los contratos",
          });
        })
        .finally(() => (_vm.loading = false));
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>